// JsonEditor.elements.js
import styled from 'styled-components'

export const JsonEditorTextarea = styled.textarea`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  font-weight: 400;
  outline: none;
  resize: vertical;
  color: ${({ theme }) => theme.colors.primary};
  -webkit-font-smoothing: antialiased;

  background-color: ${({ disabled, theme }) => (disabled ? 'transparent' : theme.colors.backgroundLite)};
  border: ${({ theme, error }) => (error ? `2px solid ${theme.colors.error}` : `1px solid ${theme.colors.backgroundLite}`)};

  font-family: monospace;

  &::placeholder {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.error};
  font-size: 14px;
  margin-top: 5px;
`
